import React, { useCallback } from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChatMessageDeleteModal = props => {
  const handleClick = useCallback(() => {
    props.handleClick(props.id);
  }, [props]);
  return /*#__PURE__*/_jsxs("div", {
    className: modalStyles.container,
    children: [/*#__PURE__*/_jsx("header", {
      children: /*#__PURE__*/_jsx("h3", {
        children: "\u30C1\u30E3\u30C3\u30C8\u3092\u524A\u9664\u3057\u307E\u3059"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: modalStyles.chatMessageDisplay,
      children: /*#__PURE__*/_jsxs("div", {
        className: modalStyles.chatMessage,
        children: [/*#__PURE__*/_jsx("span", {
          className: modalStyles.username,
          children: props.displayName
        }), /*#__PURE__*/_jsx("span", {
          className: modalStyles.messageContent,
          children: props.postDesc
        })]
      })
    }), /*#__PURE__*/_jsx(Button, {
      fillWhiteColor: true,
      fontFixed: true,
      large: true,
      onClick: handleClick,
      children: "\u524A\u9664\u3059\u308B"
    }), /*#__PURE__*/_jsx(Button, {
      fontFixed: true,
      large: true,
      borderLight: true,
      onClick: props.modalCloseHandle,
      children: "\u9589\u3058\u308B"
    })]
  });
};
export default ChatMessageDeleteModal;